import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../../config";
import { Loader2, ChevronLeft, ChevronRight, Inbox, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PriceQueryList = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});

  useEffect(() => {
    fetchData();
  }, [page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${API_URL}/api/price-query/price-query?page=${page}&limit=10`,
      );

      setData(res.data.data || []);

      setPagination({
        total: res.data.count,
        totalPages: res.data.totalPages,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const map = {
      New: "bg-primary",
      contacted: "bg-warning text-dark",
      resolved: "bg-success",
      qualified: "bg-info",
      lost: "bg-danger",
    };
    return `badge ${map[status] || "bg-secondary"} px-2 py-1`;
  };

  if (loading) {
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center bg-dark text-white">
        <Loader2 className="spin" size={50} />
      </div>
    );
  }

  return (
    <div className="container py-4 text-white">
      <div className="card border-0 rounded-4">
        {/* HEADER */}
        <div className="card-header border-0" style={{ background: "#6600cc" }}>
          <h5 className="text-white mb-0">Price Queries</h5>
          <p className="mb-0">List of all price queries</p>
        </div>

        {/* TABLE */}
        <div className="table-responsive">
          <table className="table text-white mb-0">
            <thead>
              <tr>
                <th>Organization</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Status</th>
                <th>Date</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((item) => (
                  <tr key={item._id}>
                    <td>{item.organization}</td>
                    <td>{item.email}</td>
                    <td>{item.phone}</td>

                    <td>
                      <span className={getStatusBadge(item.status)}>
                        {item.status}
                      </span>
                    </td>

                    <td>{new Date(item.createdAt).toLocaleDateString()}</td>

                    <td>
                      <button
                        onClick={() => navigate(`/price-query/${item._id}`)}
                        className="btn btn-sm"
                        style={{
                          border: "1px solid #3b82f6",
                          color: "#60a5fa",
                        }}
                      >
                        <Eye size={14} /> View
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-5">
                    <Inbox size={40} />
                    <p>No data found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-between p-3">
          <button
            className="btn btn-primary"
            disabled={page <= 1}
            onClick={() => setPage(page - 1)}
          >
            <ChevronLeft /> Prev
          </button>

          <span className="text-black">
            {page} / {pagination.totalPages || 1}
          </span>

          <button
            disabled={page >= (pagination.totalPages || 1)}
            onClick={() => setPage(page + 1)}
            className="btn btn-primary"
          >
            Next <ChevronRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PriceQueryList;
